"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldShowVidyardInitialState = exports.getHasAcceptedImportCopyrightNotice = exports.getIsVideoPQLBannerDismissed = exports.hasFetchedPortalMeta = exports.getFileManagerPortalDataFetchRequestStatus = exports.getFileManagerPortalDataUpdateRequestStatus = exports.getVidyardTosStatus = void 0;

var _reselect = require("reselect");

var _Constants = require("../Constants");

var _Auth = require("./Auth");

var getVidyardTosStatus = function getVidyardTosStatus(state) {
  return state.portalMeta.get('vidyardTosStatus');
};

exports.getVidyardTosStatus = getVidyardTosStatus;

var getFileManagerPortalDataUpdateRequestStatus = function getFileManagerPortalDataUpdateRequestStatus(state) {
  return state.portalMeta.get('updateRequestStatus');
};

exports.getFileManagerPortalDataUpdateRequestStatus = getFileManagerPortalDataUpdateRequestStatus;

var getFileManagerPortalDataFetchRequestStatus = function getFileManagerPortalDataFetchRequestStatus(state) {
  return state.portalMeta.get('fetchRequestStatus');
};

exports.getFileManagerPortalDataFetchRequestStatus = getFileManagerPortalDataFetchRequestStatus;
var hasFetchedPortalMeta = (0, _reselect.createSelector)([getFileManagerPortalDataFetchRequestStatus], function (status) {
  return status === _Constants.RequestStatus.SUCCEEDED;
});
exports.hasFetchedPortalMeta = hasFetchedPortalMeta;

var getIsVideoPQLBannerDismissed = function getIsVideoPQLBannerDismissed(state) {
  return state.portalMeta.get('isVideoPQLBannerDismissed');
};

exports.getIsVideoPQLBannerDismissed = getIsVideoPQLBannerDismissed;

var getHasAcceptedImportCopyrightNotice = function getHasAcceptedImportCopyrightNotice(state) {
  return state.portalMeta.get('importImageCopyrightNotice') === _Constants.ImportImageCopyrightNoticeValues.ACCEPTED;
};

exports.getHasAcceptedImportCopyrightNotice = getHasAcceptedImportCopyrightNotice;
var getShouldShowVidyardInitialState = (0, _reselect.createSelector)([_Auth.getHasVideoIntegrationScope, getVidyardTosStatus, getFileManagerPortalDataFetchRequestStatus], function (hasVideoIntegrationScope, vidyardTosStatus, fetchStatus) {
  return hasVideoIntegrationScope && fetchStatus === _Constants.RequestStatus.SUCCEEDED && [_Constants.VidyardTosStatus.NOT_ASKED, _Constants.VidyardTosStatus.DISABLED, _Constants.VidyardTosStatus.UNSYNCED].includes(vidyardTosStatus);
});
exports.getShouldShowVidyardInitialState = getShouldShowVidyardInitialState;